import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../components/modal/modal";

const Settings = () => {
  const { t } = useTranslation();

  const [modalMessage, setModalMessage] = useState(null);
  const [view, setView] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    email: "",
    tel: "",
    currentPassword: "",
    newPassword: "",
  });

  // 🔹 Загружаем данные пользователя
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userId = localStorage.getItem("userId");
        if (!userId) return;

        const response = await fetch(
          `/api/get_user.php?id=${userId}`
        );
        const data = await response.json();

        if (data.success && data.user) {
          setFormData((prev) => ({
            ...prev,
            name: data.user.name || "",
            lastName: data.user.lastName || "",
            email: data.user.email || "",
            tel: data.user.tel || "",
          }));
        }
      } catch (err) {
        console.error("Fetch user error:", err);
      }
    };

    fetchUser();
  }, []);

  const handleView = () => setView(!view);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // 🔹 Отправка формы (FormData)
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const userId = localStorage.getItem("userId");
      const formDataToSend = new FormData();

      Object.entries(formData).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formDataToSend.append(key, value);
        }
      });

      formDataToSend.append("id", userId);

      const response = await fetch("/api/update_user.php", {
        method: "POST",
        body: formDataToSend,
      });

      const data = await response.json();

      if (data.success) {
        setModalMessage({
          title: t("success"),
          ok: t("ok"),
          text: t("savechangessms"),
          success: true,
        });
      } else {
        setModalMessage({
          title: t("error"),
          ok: t("ok"),
          text: data.message || t("errortitle"),
          success: false,
        });
      }
    } catch (err) {
      console.error("Update error:", err);
      setModalMessage({
        title: t("error"),
        ok: t("ok"),
        text: t("errortitle"),
        success: false,
      });
    }
  };

  return (
    <section className="h-screen opacity-0 py-[20px] animate-[showtitle_1s_forwards]">
      {modalMessage && (
        <Modal
          title={modalMessage.title}
          ok={modalMessage.ok}
          text={modalMessage.text}
          success={modalMessage.success}
          onClose={() => setModalMessage(null)}
        />
      )}

      <form
        onSubmit={handleSubmit}
        className="w-[450px] max-sm:w-[90%] h-auto m-[50px_auto] opacity-0 animate-[showtitle_1s_forwards]
       transition-all duration-500 hover:-translate-y-3 flex justify-start items-start flex-col gap-3
        rounded-2xl bg-white shadow-2xl shadow-black border-[2px] border-[#006674]"
      >
        <h1
          className="font-bold tracking-widest bg-[#006674] py-3 rounded-t-xl
       text-white w-full text-center uppercase text-3xl max-sm:text-xl"
        >
          {t("settings") || "Կարգավորումներ"}
        </h1>

        <div className="w-full p-5 flex justify-start items-start flex-col gap-1">
          {/* Имя */}
          <label htmlFor="name" className="text-[#006674] max-sm:text-sm">
            {t("name")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border border-gray-400
          focus:border-[#006674] focus:shadow-xl"
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />

          {/* Фамилия */}
          <label htmlFor="lastName" className="text-[#006674] max-sm:text-sm">
            {t("lastname")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border border-gray-400
          focus:border-[#006674] focus:shadow-xl"
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
          />

          {/* Телефон */}
          <label htmlFor="tel" className="text-[#006674] max-sm:text-sm">
            {t("phone")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border border-gray-400
          focus:border-[#006674] focus:shadow-xl"
            type="tel"
            id="tel"
            name="tel"
            value={formData.tel}
            onChange={handleChange}
          />

          {/* Email */}
          <label htmlFor="email" className="text-[#006674] max-sm:text-sm">
            {t("email")}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border border-gray-400
          focus:border-[#006674] focus:shadow-xl"
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />

          {/* Текущий пароль */}
          <label
            htmlFor="currentPassword"
            className="text-[#006674] max-sm:text-sm"
          >
            {t("currentPassword") || "Ներկայիս գաղտնաբառ"}
          </label>
          <input
            className="w-full py-2 px-4 outline-none rounded-md border border-gray-400
          focus:border-[#006674] focus:shadow-xl"
            type={view ? "text" : "password"}
            id="currentPassword"
            name="currentPassword"
            placeholder="*******"
            value={formData.currentPassword}
            onChange={handleChange}
          />

          {/* Кнопка показать форму смены пароля */}
          {!showNewPassword && (
            <button
              type="button"
              className="py-2 px-4 bg-[#006674] text-white rounded-[30px] mt-3"
              onClick={() => setShowNewPassword(true)}
            >
              {t("changePassword") || "Сменить пароль"}
            </button>
          )}

          {/* Новый пароль */}
          {showNewPassword && (
            <>
              <label
                htmlFor="newPassword"
                className="text-[#006674] max-sm:text-sm"
              >
                {t("newpassword") || "Նոր գաղտնաբառ"}
              </label>
              <div className="flex w-full justify-between items-center gap-3">
                <input
                  className="w-full py-2 px-4 outline-none rounded-md border border-gray-400
              focus:border-[#006674] focus:shadow-xl"
                  type={view ? "text" : "password"}
                  id="newPassword"
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleChange}
                />
                <button
                  onClick={handleView}
                  type="button"
                  className="min-w-[40px] min-h-[40px] rounded-full bg-[#006674] text-white"
                >
                  {view ? (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  ) : (
                    <FontAwesomeIcon icon={faEye} />
                  )}
                </button>
              </div>
            </>
          )}

          {/* Сохранить */}
          <button
            type="submit"
            className="py-2 capitalize px-4 w-full mt-3 bg-[#006674] text-white rounded-[30px]
          transition-all duration-200 hover:bg-[#848484]"
          >
            {t("saveChanges") || "Պահպանել փոփոխությունները"}
          </button>
        </div>
      </form>
    </section>
  );
};

export default Settings;
